module.exports = __webpack_public_path__ + "static/media/img-thumbnail-nextsix@2x.4715798f.png";